var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgAssets = function SvgAssets(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9984 6.67188C14.845 6.67188 10.665 10.8519 10.665 16.0052C10.665 21.1599 14.845 25.3385 19.9984 25.3385C25.153 25.3385 29.3317 21.1599 29.3317 16.0052C29.3317 10.8519 25.153 6.67188 19.9984 6.67188ZM19.9977 9.33594C23.6751 9.33594 26.6644 12.3266 26.6644 16.0026C26.6644 19.6799 23.6751 22.6693 19.9977 22.6693C16.3217 22.6693 13.3311 19.6799 13.3311 16.0026C13.3311 12.3266 16.3217 9.33594 19.9977 9.33594Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07182 7.14533C5.27828 8.39397 2.66602 11.9415 2.66602 15.9958C2.66602 20.0501 5.27828 23.5977 9.07182 24.8463C9.77128 25.0765 10.5249 24.6961 10.7552 23.9967C10.9854 23.2972 10.605 22.5436 9.90555 22.3133C7.19742 21.4219 5.33268 18.8896 5.33268 15.9958C5.33268 13.1021 7.19742 10.5697 9.90555 9.67831C10.605 9.44808 10.9854 8.69442 10.7552 7.99495C10.5249 7.29549 9.77128 6.9151 9.07182 7.14533Z",
    fill: "currentColor"
  })));
};
export default SvgAssets;